import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MercadoPagoService {
  private baseUrl = '/api';

  constructor(private http: HttpClient) { }

  /**
   * Crear preferencia de pago para Mercado Pago
   * @param payload Datos del pago (items, payer, etc)
   * @returns Observable con preferenceId
   */
  createOrder(payload: any): Observable<any> {
    console.log('Enviando solicitud de pago:', payload);

    return this.http.post<any>(`${this.baseUrl}/createPayment`, payload).pipe(
      tap((response: any) => {
        console.log('Respuesta del servidor:', response);
        // Guardar preferenceId en localStorage para referencia
        if (response.preferenceId) {
          localStorage.setItem('idPago', response.preferenceId);
        }
      }),
      catchError((error: any) => {
        console.error('Error al crear orden:', error);
        return throwError(() => new Error(error.error?.message || 'Error al procesar el pago'));
      })
    );
  }

  /**
   * Obtener estado de un pago
   * @param paymentId ID del pago en Mercado Pago
   * @returns Observable con estado del pago
   */
  getPaymentStatus(paymentId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/payment-status/${paymentId}`).pipe(
      tap((response: any) => {
        console.log('Estado del pago:', response);
      }),
      catchError((error: any) => {
        console.error('Error al obtener estado del pago:', error);
        return throwError(() => new Error('Error al obtener estado del pago'));
      })
    );
  }

  getPaymentStatusValue(paymentId: string): Observable<any> {
    return this.http.get<any>(
        `${this.baseUrl}/getPaymentStatus/${paymentId}`);
  }

  /**
   * Obtener preferenceId guardado en localStorage
   */
  getStoredPreferenceId(): string | null {
    return localStorage.getItem('idPago');
  }

  /**
   * Limpiar preferenceId del localStorage
   */
  clearStoredPreferenceId(): void {
    localStorage.removeItem('idPago');
  }
}
